// =====================================================
// CLAUDE API WRAPPER (via Vercel serverless proxy)
// =====================================================

const API_ENDPOINT = "/api/chat";

/**
 * Send a message to Claude via the serverless proxy.
 */
export async function callClaude(systemPrompt, messages) {
  const response = await fetch(API_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ systemPrompt, messages, maxTokens: 1000 }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `API Error ${response.status}`);
  }

  const data = await response.json();
  return data.text || "";
}

/**
 * Send a chat message and get a response.
 */
export async function sendChatMessage(systemPrompt, conversationHistory) {
  try {
    const reply = await callClaude(systemPrompt, conversationHistory);
    return reply || "I couldn't generate a response. Please try again.";
  } catch (error) {
    console.error("Chat API error:", error);
    throw error;
  }
}

/**
 * Run a fit assessment against a job description.
 */
export async function assessFit(fitSystemPrompt, jobDescription) {
  try {
    const reply = await callClaude(fitSystemPrompt, [
      { role: "user", content: `Assess fit for this role/project:\n\n${jobDescription}` },
    ]);

    const cleaned = reply.replace(/```json/g, "").replace(/```/g, "").trim();
    return JSON.parse(cleaned);
  } catch (error) {
    console.error("Fit assessment error:", error);
    return {
      verdict: "worth_conversation",
      headline: "Could not complete the assessment. Please try again with more detail.",
      match_reasons: [],
      gap_flags: [],
      recommendation: "The AI could not process this input. Try providing a more detailed job description or project brief.",
    };
  }
}
